export const SPECIAL_DISPLAY_BRAND_NAMES = {
  adidas: 'adidas',
  'a.p.c.': 'A.P.C.',
  asics: 'ASICS',
  bape: 'BAPE',
  chloe: 'Chloé',
  'alexander mcqueen': 'Alexander McQueen',
  arcade: 'ARCADE',
  'off-white': 'OFF-WHITE',
  'comme des garcons': 'Comme des Garcons',
  '1017-alyx-9sm': '1017 ALYX 9SM',
  '1017 alyx 9sm': '1017 ALYX 9SM',
  'born-x-raised': 'Born x Raised',
  'born x raised': 'Born x Raised',
  'eckhaus-latta': 'ECKHAUS LATTA',
  'eckhaus latta': 'ECKHAUS LATTA',
  mcq: 'MCQ',
  'genesis-ii': 'Genesis II',
  't-shirts': 'T-Shirts',
};
